import { ROUTE } from "../common/ROUTE";

export const SITE_STRINGS = {
  HEADER_LOGO_ALT: "MyDecisive.ai home",
};

export const CONTACT_SALES_HREF = "mailto:info@mydecisive.ai";

export const GET_STARTED_LINKS: { label: string; href: string }[] = [
  { label: "Explore the project", href: "https://github.com/MyDecisive" },
  { label: "Dive into Platform", href: "https://demo.mydecisive.ai/" },
  { label: "Explore the product", href: "https://mydecisive.github.io/octant-ui/" },
  { label: "Join our Slack", href: "https://inviter.co/mydecisivecommunity" },
];

export const navLinks: {
  groupName: string;
  header: boolean;
  links: {
    label: string;
    href: string;
  }[];
}[] = [
  {
    groupName: "Product",
    header: false,
    links: [
      {
        label: "Explore Octant",
        href: ROUTE.OCTANT_PARENT,
      },
      {
        label: "GitHub",
        href: "https://github.com/MyDecisive",
      },
      {
        label: "Docs",
        href: "https://docs.mydecisive.ai/",
      },
    ],
  },
  {
    groupName: "Solutions",
    header: false,
    links: [
      {
        label: "All Solutions",
        href: ROUTE.ALL_SOLUTIONS,
      },
      {
        label: "Intelligent LogStream Lab",
        href: ROUTE.INTELLIGENT_LOGSTREAM,
      },
      {
        label: "Intelligent Alerting Lab",
        href: ROUTE.INTELLIGENT_ALERTING,
      },
      {
        label: "Intelligent Trace Sampling Lab",
        href: ROUTE.INTELLIGENT_TRACE_SAMPLING,
      },
      {
        label: "PII Redaction Lab",
        href: ROUTE.PII_REDACTION,
      },
    ],
  },
  {
    groupName: "Platform",
    header: true,
    links: [
      {
        label: "Platform Overview",
        href: ROUTE.PLATFORM,
      },
      {
        label: "Intelligent LogStream Lab",
        href: ROUTE.INTELLIGENT_LOGSTREAM,
      },
      {
        label: "Intelligent Alerting Lab",
        href: ROUTE.INTELLIGENT_ALERTING,
      },
      {
        label: "Intelligent Trace Sampling Lab",
        href: ROUTE.INTELLIGENT_TRACE_SAMPLING,
      },
      {
        label: "PII Redaction Lab",
        href: ROUTE.PII_REDACTION,
      },
    ],
  },
  {
    groupName: "Company",
    header: true,
    links: [
      {
        label: "Partners",
        href: ROUTE.PARTNERS,
      },
      {
        label: "About us",
        href: ROUTE.ABOUT,
      },
      {
        label: "Careers",
        href: ROUTE.CAREERS,
      },
      {
        label: "Contact us",
        href: CONTACT_SALES_HREF,
      },
    ],
  },
  {
    groupName: "What's New",
    header: true,
    links: [
      {
        label: "News & Insights",
        href: ROUTE.NEWS,
      },
      {
        label: "Blog",
        href: ROUTE.BLOG,
      },
      {
        label: "Case Studies",
        href: ROUTE.CASE_STUDY,
      },
      {
        label: "Events",
        href: ROUTE.EVENTS,
      },
    ],
  },
  {
    groupName: "For Sales",
    header: false,
    links: [
      {
        label: "sales@mydecisive.ai",
        href: "mailto:sales@mydecisive.ai",
      },
    ],
  },
  {
    groupName: "For Media Inquiries",
    header: false,
    links: [
      {
        label: "pr@mydecisive.ai",
        href: "mailto:pr@mydecisive.ai",
      },
    ],
  },
];

export const supportLinks: {
  groupName: string;
  subtitle: string;
  links: {
    label: string;
    sublabel?: string;
    href: string;
  }[];
} = {
  groupName: "Support via Slack",
  subtitle: "We will respond within 48 business hours",
  links: [
    {
      label: "MyDecisive community",
      href: "https://mydecisivecommunity.slack.com/archives/C08LJ9Z8EBE",
    },
    {
      label: "Sign up for the community",
      sublabel: "Not yet a member?",
      href: "https://inviter.co/mydecisivecommunity",
    },
  ],
};

export const emailRegex =
  // eslint-disable-next-line no-control-regex
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

export const banner = {
  text: "MyDecisive Open Sources the Smart Telemetry Hub",
  button: "Read news",
  href: "/blog/hub_release",
};
